<template>
    <div ref="container"></div>
</template>

<script>
export default {
    name: "Turnstile",
    props: {
        sitekey: {
            type: String,
            default: window.tripper.turnstileSiteKey,
        },
        theme: {
            type: String,
            default: "light", // 'light', 'dark', or 'auto'
        },
    },
    emits: ["verify", "expire", "error"],
    data() {
        return {
            widgetId: null,
        };
    },

    mounted() {
        this.loadTurnstileScript().then(() => {
            this.renderWidget();
        });
    },

    beforeUnmount() {
        // Clean up Turnstile widget when component unmounts
        if (this.widgetId && window.turnstile) {
            window.turnstile.remove(this.widgetId);
        }
    },

    methods: {
        // Dynamically inject script tag if it doesn't exist yet
        loadTurnstileScript() {
            return new Promise((resolve) => {
                if (window.turnstile) return resolve();

                const existingScript = document.getElementById(
                    "cf-turnstile-script"
                );
                if (existingScript) {
                    existingScript.addEventListener("load", resolve);
                    return;
                }

                const script = document.createElement("script");
                script.id = "cf-turnstile-script";
                script.src =
                    "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
                script.async = true;
                script.defer = true;
                script.onload = () => resolve();
                document.head.appendChild(script);
            });
        },

        // Render the Turnstile widget into the ref container
        renderWidget() {
            if (window.turnstile && this.$refs.container) {
                this.widgetId = window.turnstile.render(this.$refs.container, {
                    sitekey: this.sitekey,
                    theme: this.theme,
                    callback: (token) => this.$emit("verify", token),
                    "expired-callback": () => this.$emit("expire"),
                    "error-callback": () => this.$emit("error"),
                });
            }
        },

        // Exposed method to allow parent forms to reset the challenge
        reset() {
            if (this.widgetId && window.turnstile) {
                window.turnstile.reset(this.widgetId);
            }
        },
    },
};
</script>
